import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { UserEmploymentInfoVm } from '../../../../shared/generated/Administration/Models/User/UserEmploymentInfoVm'
import { TypeOfEmployeeEnum } from '../../../../core/enums/generated/TypeOfEmployeeEnum';
import { ActivatedRoute } from '@angular/router';
import { SecurityService } from '../../../../core/security/security.service';
import { PermissionProfileEnum } from '../../../../core/enums/generated/PermissionProfileEnum';

@Component({
    selector: 'pcg-user-employment',
    templateUrl: './user-employment.component.html',
    styleUrls: ['./user-employment.component.scss'],
    standalone: false
})
export class UserEmploymentComponent implements OnInit {

	@Input() userId: number;

	formGroup = UserEmploymentInfoVm.Form;
    typeOfEmployee = TypeOfEmployeeEnum;
    iAmMe: boolean;
    isAdmin: boolean;

	constructor(
        private httpClient: HttpClient
        , private changeDetector: ChangeDetectorRef
        , private route: ActivatedRoute
        , private sec: SecurityService
    ) { }

	ngOnInit(): void { this.getUserMiscellaneousInfoVm(); }

	ngAfterContentChecked(): void { this.changeDetector.detectChanges(); }

	getUserMiscellaneousInfoVm() {
		let httpParams = new HttpParams().set('userId', this.userId);
        this.httpClient.get<UserEmploymentInfoVm>('api/Administration/UserEmploymentInfo/GetUserEmployementInfoVm', { params: httpParams })
            .subscribe((vm: UserEmploymentInfoVm) => {
                this.formGroup.patchValue(vm);
                this.iAmMe = Number(this.route.snapshot.params.id) == this.sec.getUser().id;
                this.isAdmin = this.sec.hasAccess(o => o.permissionProfile === PermissionProfileEnum.Admin);
            });
	}

    onMessageSuccess(event) {
        if (event.value != "") { this.formGroup.controls.fileName.patchValue(event.value); }
    }
}
